import {gql} from 'apollo-angular';
import {ImageFragment} from "./Image";

export const JobPreviewFragment = gql`
  fragment jobPreviewFields on JobMarket {
    id
    name
    positionType
    companyProfile {
      id
      name
    }
    jobs {
      id
      name
      interestFields {
        id
      }
    }
    addresses {
      addressLatLon {
        lat
        lon
      }
      addressCity {
        name
      }
    }
    image {
      ...imageFields
    }
  }
  ${ImageFragment}
`;
